import { CommonModule } from '@angular/common';
import { Component, EventEmitter, Inject, Input, OnChanges, OnInit, Output, PLATFORM_ID, SimpleChanges } from '@angular/core';
import { FormArray, FormControl, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { FormUtils } from '../../../../../shared/helpers/formUtils';
import { EYesNo } from '../../../../../shared/models/types.enum';

@Component({
  selector: 'emotional-reaction',
  standalone: true,
  imports: [
    CommonModule,
    ReactiveFormsModule
  ],
  templateUrl: './emotional-reaction.component.html',
  styleUrl: './emotional-reaction.component.css'
})
export class EmotionalReactionComponent implements OnInit, OnChanges {

  @Input() studentInterviewData: any;
  @Output() onSaveSection6 = new EventEmitter<any>();

  yesNo = EYesNo;

  emotionalReactionForm: FormGroup = new FormGroup([]);
  questionsList = [
    {
      question: 'Attitude: *',
      formControlName: 'attitude',
      answers: ['Composed', 'Polite', 'Cooperative', 'Reserved', 'Indifferent', 'Silent', 'Scared', 'Sad', 'Happy', 'Carefree', 'Cocky', 'Hilarious', 'Excited', 'Angry', 'Sarcastic', 'Antagonistic', 'Suspicious', 'Insulting', 'Profane', 'Sleepy'],
      defaultValue: 'Composed'
    },
    {
      question: 'Talk - Form: *',
      formControlName: 'talk_form',
      answers: ['Logical', 'Conversational', 'Illogical', 'Rambling', 'Nonsensical'],
      defaultValue: 'Logical'
    },
    {
      question: 'Talk - Rate: *',
      formControlName: 'talk_rate',
      answers: ['Normal', 'Under-talkative', 'Over-talkative'],
      defaultValue: 'Normal'
    },
    {
      question: 'Talk - Quality: *',
      formControlName: 'talk_quality',
      answers: ['Controlled', 'Humorous', 'Dramatic', 'Forceful', 'Shouting', 'Screaming', 'Mumbling'],
      defaultValue: 'Controlled'
    },
    {
      question: 'Expressions: *',
      formControlName: 'expressions',
      answers: ['Ideas of being persecuted', 'Feels people are watching them', 'Feels people are talking about them', 'Ideas of grandeur', 'Strange or bizarre physical complaints', 'Very self-critical', 'Hearing voices', 'Seeing things', 'Homicidal thoughts', 'Suicidal thoughts', 'Unusual sexual ideas'],
      defaultValue: 'Ideas of being persecuted'
    },
  ];

  radioQuestionList = [
    {
      question: "Does individual know who he/she is? *",
      formControlName: "self_knowledge",
    },
    {
      question: "Does individual know where he/she is? *",
      formControlName: "self_location",
    },
    {
      question: "Does individual know how he/she feels? *",
      formControlName: "self_feeling",
    }
  ]

  constructor(
    @Inject(PLATFORM_ID) private platformId: object,
    private formUtils: FormUtils
  ) {}

  ngOnInit() {
    this.initializeForm();
  }
  
  ngOnChanges(changes: SimpleChanges): void {
    if (changes['studentInterviewData'] && this.studentInterviewData) {
      this.initializeForm();
    }
  }

  onCheckboxChange(e: any, controlName: string, value: string) {
    const currentValues = new Set(this.emotionalReactionForm.get(controlName)!.value.split(', ').filter((v: string) => v));
    if (e.target.checked) {
      currentValues.add(value);
    } else {
      currentValues.delete(value);
    }
    this.emotionalReactionForm.get(controlName)?.setValue(Array.from(currentValues).join(', '));
  }

  private initializeForm() {
    const group: any = {};

    this.radioQuestionList.forEach(question => {
      group[question.formControlName] = new FormControl(String(this.studentInterviewData?.[question.formControlName]) || this.yesNo.Yes, Validators.required);
    });
    
    this.questionsList.forEach(question => {
      if (this.studentInterviewData?.[question.formControlName]) {
        const value = this.studentInterviewData[question.formControlName];
        if (value && value.includes(', ')) {
          group[question.formControlName] = new FormControl(value.split(', ').join(', '));
        } else {
          group[question.formControlName] = new FormControl(value || question.defaultValue, Validators.required);
        }
      } else {
        group[question.formControlName] = new FormControl(question.defaultValue, Validators.required);
      }
    });
  
    this.emotionalReactionForm = new FormGroup(group);
  }
  
  saveEmotionalReaction(): void {
    if (this.emotionalReactionForm.valid) {
      this.onSaveSection6.emit(this.emotionalReactionForm.value);
    }
  }


}
